<template>
  <div class="application-header">
    <div class="status-section">
      <span class="status-badge" :class="statusClass">
        {{ enrolStatus }}
      </span>
    </div>

    <div class="actions-section">
      <a
        :href="`${apiHost}/controller/Api.asmx/ExportApplicationAsPdf?id=${applicationFormId}`"
        class="el-button el-button--secondary print-button"
        target="_blank"
      >
        <i class="fa fa-print"></i>
        PRINT (PDF)
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationHeader',
  props: {
    enrolStatus: {
      type: String,
      required: true,
    },
    applicationFormId: {
      type: String,
      required: true,
    },
    apiHost: {
      type: String,
      required: true,
    },
  },

  computed: {
    statusClass() {
      return {
        'status-badge--approved': this.enrolStatus === 'Approved',
        'status-badge--pending': this.enrolStatus === 'Pending',
        'status-badge--rejected': this.enrolStatus === 'Rejected',
        'status-badge--draft': this.enrolStatus === 'Draft',
        'status-badge--closed': this.enrolStatus === 'Closed',
      }
    },
  },
}
</script>

<style scoped>
.application-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.status-section {
  display: flex;
  align-items: center;
}

.status-badge {
  padding: 8px 16px;
  border-radius: 6px;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge--approved {
  background: #28a745;
}

.status-badge--pending {
  background: #ffc107;
  color: #212529;
}

.status-badge--rejected {
  background: #dc3545;
}

.status-badge--draft {
  background: #6c757d;
}

.status-badge--closed {
  background: #343a40;
}

.actions-section {
  display: flex;
  gap: 10px;
}

.print-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #6c757d;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.print-button:hover {
  background: #5a6268;
  color: white;
  text-decoration: none;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.print-button i {
  font-size: 16px;
}

@media (max-width: 768px) {
  .application-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .status-section,
  .actions-section {
    width: 100%;
    justify-content: center;
  }
}
</style>
